<template>
  <div
    :class="['zg-testimonial', {
      [`zg-testimonial--background-${background}`]: background
    }]"
  >
    <div class="header">
      <zg-avatar
        :image="image"
        :text="initials"
        :background="avatarBackground"
        size="large"
      />

      <zg-trustpilot-stars :stars="stars" />
    </div>

    <div class="content">
      <h6>
        {{ author }}
      </h6>

      <p>
        {{ maxTextLength(text, 100) }}
      </p>

      <span>{{ date }}</span>
    </div>
  </div>
</template>

<script>
  import ZgAvatar from '../ZgAvatar/ZgAvatar'
  import ZgTrustpilotStars from '../ZgTrustpilot/ZgTrustpilotStars.vue'

  export default {
    name: 'ZgTestimonial',
    components: {
      ZgAvatar,
      ZgTrustpilotStars
    },
    props: {
      image: {
        type: String,
        required: false,
        default: null
      },
      author: {
        type: String,
        required: true
      },
      stars: {
        type: Number,
        required: true
      },
      text: {
        type: String,
        required: true
      },
      date: {
        type: String,
        required: false,
        default: null
      },
      background: {
        type: String,
        required: false,
        default: 'white',
        validator: value => [
          'beige',
          'white'
        ].includes(value)
      }
    },
    computed: {
      avatarBackground () {
        return this.background === 'beige' ? 'white' : 'beige'
      },
      initials () {
        return this.author
          ?.split(' ')
          ?.map(n => n[0]).join('')
      }
    },
    methods: {
      maxTextLength (text, length = 100) {
        return text?.length > length
          ? `${text.slice(0, length)}...`
          : text
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-testimonial {
    display: flex;
    flex-direction: column;
    gap: rem(24px);
    padding: rem(24px) rem(24px) rem(32px);
    border-radius: radius(large);

    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: rem(16px);
    }

    .content {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      gap: rem(6px);

      h6 {
        @include type-title-s;

        margin: 0;
      }

      p {
        @include type-body-s;

        margin: 0;
      }

      span {
        @include type-body-s;

        color: color(gray-500);
        margin: auto 0 0;
      }
    }
  }

  // ? ----------------------------------------------------------------------
  // background
  // ? ----------------------------------------------------------------------

  .zg-testimonial--background-white {
    background-color: color(white);
  }

  .zg-testimonial--background-beige {
    background-color: color(beige);
  }
</style>
